import actionTypes from './actionTypes'

const lessonSessionActions = {

	metadataSuccess(metadata) {
		return {
			type: actionTypes.LESSON_SESSION_METADATA_SUCCESS,
			metadata,
		}
	},

}

export default lessonSessionActions
